import * as Sentry from '@sentry/react'
import { allconfig } from './config'

let initialized = false

export const initSentry = () => {
  if (initialized) return Sentry

  const dsn = process.env.REACT_APP_SENTRY_DSN
  if (!dsn) return Sentry

  const integrations = []
  if (typeof Sentry.browserTracingIntegration === 'function') {
    integrations.push(Sentry.browserTracingIntegration())
  }

  Sentry.init({
    dsn,
    environment: allconfig.env || process.env.NODE_ENV || 'development',
    tracesSampleRate: allconfig.env === 'prod' || allconfig.env === 'PROD' ? 0.1 : 1.0,
    sendDefaultPii: false,
    integrations
  })

  initialized = true
  return Sentry
}

export const captureException = (error, context = {}) => {
  if (!initialized || !process.env.REACT_APP_SENTRY_DSN || !error) return

  Sentry.withScope((scope) => {
    if (context.tags) {
      Object.entries(context.tags).forEach(([key, value]) => scope.setTag(key, value))
    }
    if (context.extra) {
      Object.entries(context.extra).forEach(([key, value]) => scope.setExtra(key, value))
    }
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)))
  })
}

export const captureMessage = (message, level = 'error', context = {}) => {
  if (!initialized || !process.env.REACT_APP_SENTRY_DSN || !message) return

  Sentry.withScope((scope) => {
    if (context.tags) {
      Object.entries(context.tags).forEach(([key, value]) => scope.setTag(key, value))
    }
    if (context.extra) {
      Object.entries(context.extra).forEach(([key, value]) => scope.setExtra(key, value))
    }
    Sentry.captureMessage(String(message), level)
  })
}

export { Sentry }
